import { z } from 'zod';

import { api } from '@/shared/api';
import { unwrap } from '@/shared/api/envelope';

/**
 * De **actieve omgeving**: het keuringsbedrijf waarvoor je op dit moment werkt.
 * Naam en logo staan in de kopbalk van elk kantoorscherm; normaal komen ze
 * uit de sessie, dit is de terugval (`GET /tenant`).
 */
export interface Organisation {
    id: string;
    name: string;
    logo_url: string | null;
}

/** (`Tenancy\TenantResource`) - alleen wat de kopbalk nodig heeft. */
const tenantHeaderResourceSchema = z.object({
    uuid: z.string(),
    name: z.string(),
    logo_url: z.string().nullable(),
});

export const organisationKeys = {
    current: () => ['organisation', 'current'] as const,
};

/** "Keurhuis Voorbeeld Zuid-West" -> "HZ". */
export function organisationInitials(name: string): string {
    return name
        .split(/[\s-]+/)
        .filter(Boolean)
        .slice(0, 2)
        .map((part) => part.charAt(0).toUpperCase())
        .join('');
}

/**
 * (`Tenancy\TenantSettingsResource`) - alleen de instellingen die de
 * kantoorschermen gebruiken. camelCase, gelijk aan de opslag.
 */
export const organisationSettingsSchema = z.object({
    autoSendReport: z.boolean().catch(true),
});

export type OrganisationSettings = z.infer<typeof organisationSettingsSchema>;

export const organisationApi = {
    async current(): Promise<Organisation> {
        const tenant = unwrap(tenantHeaderResourceSchema, await api.get('/tenant'));

        return { id: tenant.uuid, name: tenant.name, logo_url: tenant.logo_url };
    },

    /** `GET /tenant/settings` - o.a. of rapporten automatisch de deur uit gaan. */
    async settings(): Promise<OrganisationSettings> {
        return unwrap(organisationSettingsSchema, await api.get('/tenant/settings'));
    },
};
